import { render, staticRenderFns } from "./MySubcommunities.vue?vue&type=template&id=22a0fce9"
import script from "./MySubcommunities.vue?vue&type=script&lang=js"
export * from "./MySubcommunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports